import {
	useCallback,
	useContext
} from 'react';
import createDataContext from '../services/createDataContext';

import authReducer, {
	SIGN_IN,
	SIGN_OUT
} from '../reducers/authReducer';

export let controller = new AbortController();

const initialState = { user: null };

const onInit = () => {
	controller = new AbortController();
};

const onCleanup = () => {
	controller.abort();
};

export const {
	StateContext,
	ActionContext,
	Provider
} = createDataContext( {
	reducer: authReducer,
	initialState,
	controller,
	onInit,
	onCleanup
} );

export function useAuthState() {
	const state = useContext( StateContext );

	return state;
}

export function useAuthAction() {
	const dispatch = useContext( ActionContext );

	const signIn = useCallback( userProfile => {
		SIGN_IN( dispatch, controller.signal )( userProfile );
	}, [ dispatch ] );

	const signOut = useCallback( () => {
		sessionStorage.clear();
		SIGN_OUT( dispatch, controller.signal )();
	}, [ dispatch ] );

	return {
		signIn,
		signOut
	};
}
